import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Fashion%20editorial%20photography%20of%20a%20woman%20in%20flowing%20deep%20burgundy%20dress%20standing%20in%20dramatic%20pose%2C%20wind%20sweeping%20through%20the%20fabric%2C%20dark%20moody%20atmosphere%20with%20warm%20golden%20highlights%2C%20luxury%20fashion%20aesthetic%2C%20powerful%20feminine%20energy%2C%20high%20contrast%20editorial%20style%2C%20cream%20and%20dark%20background%20gradient&width=1920&height=1080&seq=hero-main-bg&orientation=landscape"
          alt="裙子下面是野兽 - 女性野性力量时尚"
          title="裙子下面是野兽 - 女性野性力量时尚"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <p className="font-heading text-accent-300 text-sm md:text-base tracking-[0.3em] uppercase mb-6 animate-fade-in whitespace-nowrap">
          The Beast Beneath The Skirt
        </p>
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-6 tracking-wide">
          裙子下面
          <br />
          <span className="text-accent-400">是野兽</span>
        </h1>
        <p className="text-background-200 text-base md:text-lg max-w-xl mx-auto leading-relaxed mb-10 font-body">
          在优雅的裙摆之下，潜藏着每一位女性内心深处最原始、最自由的野性力量。<br />
          这里不是束缚你的牢笼，而是释放你的猎场。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/articles"
            className="px-8 py-3.5 bg-primary-500 text-background-50 font-medium text-sm tracking-wider rounded-md hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            探索风格宣言
          </Link>
          <Link
            to="/categories"
            className="px-8 py-3.5 border border-background-300/40 text-background-50 font-medium text-sm tracking-wider rounded-md hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap"
          >
            发现你的野兽
          </Link>
        </div>
      </div>

      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10">
        <a
          href="#philosophy"
          className="flex flex-col items-center gap-2 text-background-50/60 hover:text-background-50 transition-colors duration-300"
        >
          <span className="text-xs tracking-widest uppercase">向下探索</span>
          <i className="ri-arrow-down-line text-lg animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}